import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExternalApiUrls } from 'projects/bis-shared/src/lib/utility/apiurls-external';
import { WillHandleErrorMessagingOption } from 'projects/bis-shared/src/lib/utility/http-options';
import { PriorAuthWorkRequestAssignee } from 'projects/bis-shared/src/lib/work-request-shared/prior-auth-work-request-assignee';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PriorAuthWorkRequestService {
  constructor(private http: HttpClient, private externalApiUrls: ExternalApiUrls) {}

  getPriorAuthWorkRequestAssignees(
    getAssigneesRequest: any,
  ): Observable<PriorAuthWorkRequestAssignee[]> {
    return this.http.post<PriorAuthWorkRequestAssignee[]>(
      this.externalApiUrls.priorAuthorization.priorAuthorizationWorkRequestAssignees(),
      getAssigneesRequest,
    );
  }

  assignPriorAuthWorkRequest(assigneeForm: any): Observable<boolean> {
    return this.http.post<boolean>(
      this.externalApiUrls.priorAuthorization.assignPriorAuthWorkRequest(),
      assigneeForm,
      WillHandleErrorMessagingOption,
    );
  }

  getWorkloadAdminStatus(): Observable<boolean> {
    return this.http.get<boolean>(this.externalApiUrls.priorAuthorization.getWorkloadAdminStatus());
  }
}
